import styled from 'styled-components'
import { COLORS } from 'utils'

interface ILine {
  background?: string
}
export const Line = styled.div<ILine>`
  width: 100%;
  height: 0.5rem;
  background: ${({ background }) => background || COLORS.primary};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`
